<template>
  <div class="mt-5">
    <v-layout>
      <v-flex>
        <v-btn flat @click="onBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="grey" @click="onSave" v-if="!isSaveOnly">
          <i class="fas fa-save mr-1"></i>
          {{ $t('save_draft') }}
        </v-btn>
        <v-btn depressed color="primary" @click="onSend">
          <i class="fas fa-paper-plane mr-1"></i>
          {{ $t(isSaveOnly ? 'save_and_send' : 'Send') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container>
      <h3 class="headline">{{ $t('Broadcast Detail') }}</h3>
    </v-container>
    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('broadcastName') }">
          <input
            type="text"
            class="form-control"
            name="broadcastName"
            data-vv-name="broadcastName"
            :data-vv-as="$t('Broadcast Name')"
            :placeholder="$t('Broadcast Name')"
            v-validate="'required'"
            v-model="name"
          />
          <span class="text-error" v-show="errors.has('broadcastName')">{{
            errors.first('broadcastName')
          }}</span>
        </div>
      </v-container>

      <template
        v-if="
          ['', 'all', 'facebook'].includes(groupType.value) ||
          (groupType.value == 'customize' && filter.app.value != 'line')
        "
      >
        <v-divider></v-divider>
        <v-container>
          <div>
            {{ $t('Message Type') }}
            <span class="primary-color" v-if="sendtype === 'NTN_BROADCAST'"
              >( จำนวนโควต้าการบรอดแคสต์คงเหลือ
              <tween-num
                :value="
                  tntType.value == 'DAILY'
                    ? parseInt(count_optin_daily_available)
                    : tntType.value == 'WEEKLY'
                    ? parseInt(count_optin_weekly_available)
                    : tntType.value == 'MONTHLY'
                    ? parseInt(count_optin_monthly_available)
                    : false
                "
                :initial="0"
                :formatter="numberFormat"
                key="promotion"
              ></tween-num>
              ผู้ใช้ )</span
            >
          </div>
          <a href="https://blog.zwiz.ai/5typesfbbroadcast/" target="_blank">{{
            $t(
              'To avoid being blocked by Facebook, click here to read more about how to use each Message Type'
            )
          }}</a>
          <v-radio-group v-model="sendtype">
            <v-layout wrap>
              <v-flex xs12 sm6 md4 class="py-2">
                <v-radio
                  :label="$t('Promotional Message (within 24 hours)')"
                  value="promotion"
                  color="primary"
                ></v-radio>
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-2 d-flex">
                <v-radio
                  value="ACCOUNT_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    {{ $t('Account Update') }}
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-2">
                <v-radio
                  value="CONFIRMED_EVENT_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    {{ $t('Confirmed Event Update') }}
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                class="py-2"
                v-if="$store.state.ntnPage.includes(selectedBot.pageid)"
              >
                <v-radio
                  value="NTN_BROADCAST"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    <div>
                      <span style="color: red"> New </span>
                      {{ $t('recurring_notification_broadcasts') }}
                      <v-modal-help>
                        <div slot="body">
                          <img class="responsive-img" src="/static/img/assets/help/NTN-01.jpg" />
                          <div style="padding: 15px">
                            <p class="strong">{{ $t('recurring_notification') }}</p>

                            <span class="ml-4">
                              {{ $t('how_to_set_recurring_notification1') }}
                            </span>
                            <p class="mt-3">
                              {{ $t('how_to_set_recurring_notification2') }}
                            </p>
                            <ol class="ml-4 mt-3" type="1" style="margin-bottom: 15px">
                              <li style="list-style: decimal">
                                {{ $t('how_to_set_recurring_notification3') }}
                              </li>
                              <li style="list-style: decimal">
                                {{ $t('how_to_set_recurring_notification4') }}
                              </li>
                              <li style="list-style: decimal">
                                {{ $t('how_to_set_recurring_notification5') }}
                              </li>
                            </ol>
                          </div>
                        </div>
                      </v-modal-help>
                    </div>
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
                <small class="primary-color">{{ $t('remark_recurring_notification') }}</small>
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-2">
                <v-radio
                  value="POST_PURCHASE_UPDATE"
                  color="primary"
                  :disabled="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                >
                  <template v-slot:label>
                    {{ $t('Post-Purchase Update') }}
                    <v-chip
                      class="white--text"
                      v-if="
                        selectedBot.pagetype != 'enterprise' &&
                        $store.getters.getPackage != 'premium'
                      "
                      small
                      color="primary"
                      >{{ $t('premium') }}</v-chip
                    >
                  </template>
                </v-radio>
              </v-flex>
              <v-flex xs12 sm6 md4 class="py-2">
                <v-radio
                  :label="$t('Promotional Message (Sponsored Message to all users)')"
                  value="sponsered"
                  color="primary"
                ></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>

          <v-dialog v-model="showSponser" max-width="640">
            <v-card>
              <div class="text-xs-right">
                <v-btn fab flat small @click="showSponser = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="text-xs-center">
                  <h4 v-html="$t('If you want to send Promotional Message to all users')"></h4>
                  <v-btn
                    class="mb-2"
                    href="https://blog.zwiz.ai/handlefbpolicy2020/"
                    color="primary"
                    depressed
                    target="_blank"
                    >{{ $t('click here') }}</v-btn
                  >
                  <div class="mb-5 grey--text">
                    {{ $t('to learn “How to use Sponsored Message?”') }}
                  </div>
                  <div class="mb-4">
                    <span class="warning--text">{{ $t('Remark') }}</span>
                    {{ $t('This Message Type must be managed in Facebook Ads Manager') }}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- <a
            href="https://blog.zwiz.ai/handlefbpolicy2020/"
            target="_blank"
          >{{$t('Promotional Message (Sponsored Message to all users)')}}</a>-->
        </v-container>
      </template>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Notification Setting') }}</div>
        <v-radio-group v-model="pushtype" row>
          <v-radio
            :label="$t('silent push')"
            value="SILENT_PUSH"
            color="primary"
            v-tooltip.top="
              $t(
                'Silent Push notification will display a phone notification without sound. Use it for regular messages that dont require immediate action.'
              )
            "
          ></v-radio>
          <v-radio
            :label="$t('regular push')"
            value="REGULAR"
            color="primary"
            v-tooltip.top="
              $t(
                'Regular Push notification will make a sound and display a phone notification. Use it for important messages.'
              )
            "
          ></v-radio>
          <v-radio
            :label="$t('no push')"
            value="NO_PUSH"
            color="primary"
            v-tooltip.top="
              $t(
                'No Push notification will not display a phone notification and make any sound. Use it for messages that dont require immediate action.'
              )
            "
          ></v-radio>
        </v-radio-group>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <template v-if="loadingEstimate">
          <sync-loader
            :color="$vuetify.theme.primary"
            :size="'8px'"
            style="display: inline-block; margin-bottom: 10px"
          ></sync-loader>
        </template>
        <template v-else>
          <p class="primary-color">
            {{ $t('approximately') }}
            <template v-if="sendtype === 'NTN_BROADCAST'">
              <template v-if="value === false"> N/A </template>
              <tween-num
                v-else
                :value="
                  tntType.value == 'DAILY'
                    ? parseInt(count_optin_daily)
                    : tntType.value == 'WEEKLY'
                    ? parseInt(count_optin_weekly)
                    : tntType.value == 'MONTHLY'
                    ? parseInt(count_optin_monthly)
                    : false
                "
                :initial="0"
                :formatter="numberFormat"
                key="promotion"
              ></tween-num>
              <span>&nbsp;{{ $t('users') }}</span>
            </template>
            <template v-else>
              <template v-if="groupType.value != 'line' && sendtype == 'promotion'">
                <tween-num
                  :value="parseInt(estimate_user)"
                  :initial="0"
                  :formatter="numberFormat"
                  key="promotion"
                ></tween-num>
                <span
                  >&nbsp;{{ $t('users') }}&nbsp;({{
                    $t(`Number of users who talked with chatbot within 24 hours`)
                  }})</span
                >
              </template>
              <template v-else>
                <tween-num
                  :value="parseInt(total_user)"
                  :initial="0"
                  :formatter="numberFormat"
                  key="not_promotion"
                ></tween-num>
                <span>&nbsp;{{ $t('users') }}</span>
              </template>
            </template>
          </p>
          <template
            v-if="
              selectedBot.pagetype != 'enterprise' &&
              groupType.value != 'line' &&
              sendtype == 'promotion'
            "
          >
            <div>
              {{
                $t(
                  'Broadcasts will be sent to subscribers who interacts in Messenger with the Business page within 24 hours. If you prefer to send messages to more target users (total no. {total_user}), you are required to use Sponsored Message.',
                  { total_user }
                )
              }}
              <a
                href="https://blog.zwiz.ai/handlefbpolicy2020/"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('Click') }}</a
              >
            </div>
          </template>
          <p v-if="groupType.value != 'line'">
            ***
            {{
              $t(
                '(Importing the previous users before installing the chatbot can be applied with premium package only.)'
              )
            }}
          </p>
        </template>
        <multiselect
          v-if="selectedBot.theme != 'universalutilities'"
          v-model="groupType"
          :options="groupTypeOptions"
          label="label"
          :allow-empty="false"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          track-by="label"
          @select="onSelectGroupType"
        ></multiselect>

        <div style="position: relative" v-if="groupType.value == 'customize'">
          <div class="form-control">
            <v-premium-plan-popup
              :showAll="false"
              marginTop="65"
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            ></v-premium-plan-popup>
            <template>
              <div
                style="
                  border: 1px solid #eee;
                  padding: 5px 10px 0px 10px;
                  border-radius: 10px;
                  margin-top: 15px;
                  background: #fbfbfb;
                "
              >
                <filter-customer
                  v-model="filter"
                  @onChangeStatus="onChangeStatus"
                  :total_user="total_user"
                >
                  <div v-if="selectedBot.theme == 'universalutilities'">
                    <v-divider class="mt-2"></v-divider>
                    <v-layout wrap>
                      <v-flex xs12 sm4 class="form-control pa-1 text-xs-left">
                        <label for class="caption">{{ $t('ชื่อจริง') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('ชื่อจริง')"
                          v-model="filter.uu_name"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1 text-xs-left">
                        <label for>{{ $t('ประปา') }}</label>
                        <div v-if="selectedBot.uu_areaname" class="primary--text">
                          {{ selectedBot.uu_areaname }}
                        </div>
                        <template v-else>
                          <multiselect
                            v-model="filter.uu_areaname"
                            :options="areaName"
                            selectLabel
                            selectedLabel
                            :searchable="false"
                            deselect-label
                          ></multiselect>
                        </template>
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1 text-xs-left">
                        <label for class="caption">{{ $t('DMA') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('DMA')"
                          v-model="filter.uu_dma"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex
                        v-if="selectedBot.theme == 'universalutilities'"
                        xs12
                        sm4
                        md4
                        class="form-control pa-1 text-xs-left"
                      >
                        <label>{{ $t('Register Status') }}</label>
                        <div
                          class="form-inline form-control"
                          :class="{ 'has-error': errors.has('Context') }"
                        >
                          <multiselect
                            v-model="filter.uu_register_status"
                            :options="['ลงทะเบียน', 'ไม่ลงทะเบียน']"
                            selectLabel
                            selectedLabel
                            deselect-label
                            :placeholder="$t('Register Status')"
                          ></multiselect>
                        </div>
                      </v-flex>
                      <v-flex sm12 class="text-xs-center">
                        <template v-if="selectedBot.theme == 'universalutilities'">
                          <div
                            v-if="messageAvailableCount !== false"
                            class="primary--text text-xs-left mt-2"
                            style="display: inline"
                          >
                            <template v-if="loadingLinePushMessageCount">
                              <v-progress-circular
                                color="primary"
                                indeterminate
                              ></v-progress-circular>
                            </template>
                            <template v-else
                              >จำนวนที่เคยส่ง {{ messageAvailableCount }} ข้อความ</template
                            >
                          </div>
                        </template>
                      </v-flex>
                    </v-layout>
                  </div>

                  <div slot="append" slot-scope="{ filter }" v-if="selectedBot.theme == 'hafele'">
                    <v-divider class="mt-2"></v-divider>
                    <v-layout wrap>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Emp ID') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('Emp ID')"
                          v-model="filter.emp_id"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Emp First Name') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('Emp First Name')"
                          v-model="filter.emp_first_name"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Emp Last Name') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('Emp Last Name')"
                          v-model="filter.emp_last_name"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Division') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('Division')"
                          v-model="filter.division"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                      <v-flex xs12 sm4 class="form-control pa-1">
                        <label for class="caption">{{ $t('Department') }}</label>
                        <input
                          type="text"
                          :placeholder="$t('Department')"
                          v-model="filter.department"
                          class="form-control"
                          maxlength="255"
                        />
                      </v-flex>
                    </v-layout>
                  </div>
                </filter-customer>
              </div>
            </template>
          </div>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <template v-if="type == 'json'">
          <div>
            <intent-group
              v-model="messages"
              :hasAlternative="false"
              :isWelcome="true"
              :availableBubbles="availableBubbles"
            ></intent-group>
          </div>
          <div>
            <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>
            <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <tags
                v-model="choice"
                :tags="choices"
                @tags-changed="addChoices"
                @before-adding-tag="checkQuickReply"
                style="margin-bottom: 5px"
                :btnText="$t('Add choice')"
              ></tags>

              <span class="text-error" v-if="errorTag.length > 0">
                <template v-if="errorTag.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="errorTag.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="errorTag.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </div>
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="type == 'template'">
          <div style="overflow-x: scroll; margin-bottom: 5px">
            <div
              style="margin: 0; overflow: auto"
              :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
            >
              <div
                style="float: left; width: 300px; margin-right: 15px"
                v-for="(generic, index) in generics"
                :key="'generic_' + index"
              >
                <generic-manage
                  :vkey="index"
                  v-model="generics[index]"
                  @onDelete="onDeleteGeneric(index)"
                  :isValidate="true"
                >
                  <move-horizontal
                    slot="move"
                    :index="index"
                    :max="generics.length"
                    @onMove="onMove(index, $event)"
                    style="display: inline-block; margin-top: 0"
                  ></move-horizontal>
                </generic-manage>
              </div>
              <div
                v-if="generics.length < 10"
                @click="addGeneric"
                style="
                  position: relative;
                  float: left;
                  width: 300px;
                  border: 4px dashed #eee;
                  border-radius: 20px;
                  height: 300px;
                  cursor: pointer;
                "
              >
                <div
                  style="
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -10px;
                    margin-top: -23px;
                    font-size: 32px;
                  "
                >
                  <span class="glyphicon glyphicon-plus"></span>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </template>

        <div class="mt-4">
          <div class="hr"></div>
          <div class="text-xs-center" style="margin: -13px">
            <a
              class="text btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
              style="position: relative"
            >
              {{ $t('Advanced') }}
              <em
                class="fa"
                :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
              />
            </a>
          </div>

          <template>
            <div style="margin-top: 25px" v-show="showAdvanced">
              <div>
                {{ $t('Status') }}
                <v-premium-lock :inline="true"></v-premium-lock>
              </div>
              <div
                v-if="
                  selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                "
                class="mt-1 primary--text"
              >
                {{ update_status ? update_status : '-' }}
              </div>
              <template v-else>
                <div
                  class="form-control"
                  :class="{ 'has-error': errors.has('broadcastUpdateStatus') }"
                >
                  <!-- <input
                    type="text"
                    class="form-control"
                    name="broadcastUpdateStatus"
                    data-vv-name="broadcastUpdateStatus"
                    :data-vv-as="$t('Status')"
                    :placeholder="$t('Status')"
                    v-model="update_status"
                  /> -->
                  <v-layout wrap>
                    <v-flex sm11>
                      <multiselect
                        :options="statusOptions"
                        v-model="update_status"
                        :multiple="false"
                        :taggable="true"
                        @tag="onSelectStatus"
                      >
                      </multiselect>
                    </v-flex>
                    <v-flex sm1>
                      <v-btn samll icon @click="update_status = null">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <span class="text-error" v-show="errors.has('broadcastUpdateStatus')">{{
                    errors.first('broadcastUpdateStatus')
                  }}</span>
                </div>
              </template>

              <div class="mt-3">
                {{ $t('Tag') }}
                <v-premium-lock :inline="true"></v-premium-lock>
              </div>

              <template
                v-if="
                  selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                "
              >
                <div class="primary--text" v-if="update_tags.length == 0">
                  {{ $t('No tag') }}
                </div>
                <template v-else>
                  <template v-for="(tag, tindex) in update_tags">
                    <v-chip
                      :key="`tags_${tindex}`"
                      class="white--text"
                      disabled
                      small
                      color="primary"
                    >
                      {{ tag }}
                    </v-chip>
                  </template>
                </template>
              </template>
              <template v-else>
                <tags
                  v-if="tagOptions"
                  :combobox="true"
                  v-model="usertag"
                  :tags="usertags"
                  @tags-changed="addUserTags"
                  @before-adding-tag="checkUserTags"
                  :itemOption="tagOptions"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add tag')"
                ></tags>
                <span class="text-error" v-if="errorUsertag.length > 0">
                  <template v-if="errorUsertag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorUsertag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorUsertag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </template>
            </div>
          </template>
        </div>
      </v-container>

      <template>
        <v-divider></v-divider>
        <div style="position: relative">
          <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup>
          <v-container
            :style="{
              'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '230px' : 'auto'
            }"
          >
            <v-layout column class="form-control my-3">
              <v-flex>{{ $t('ข้อความแจ้งเตือน') }}</v-flex>
              <v-flex class="text-xs-right form-control">
                <input type="text" :placeholder="$t('ข้อความแจ้งเตือน')" v-model="notify" />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>{{ $t('Schedule Broadcast') }}</v-flex>
              <v-flex class="text-xs-right">
                <label class="toggle-switch small" style="vertical-align: bottom">
                  <input
                    type="checkbox"
                    :checked="broadcast.isschedule"
                    @change="onBroadcastSchedule"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="broadcast.isschedule">
              <v-flex xs6 class="form-control">
                <v-layout wrap>
                  <v-flex xs8>
                    <v-menu
                      ref="showScheduleDate"
                      v-model="showScheduleDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input type="text" name id v-model="scheduleDate" v-on="on" readonly />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="scheduleDate"
                        @input="showScheduleDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="showScheduleTime"
                      v-model="showScheduleTime"
                      :close-on-content-click="false"
                      :return-value.sync="scheduleTime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input type="text" name id v-model="scheduleTime" readonly v-on="on" />
                      </template>
                      <v-time-picker
                        v-if="showScheduleTime"
                        v-model="scheduleTime"
                        full-width
                        @click:minute="$refs.showScheduleTime.save(scheduleTime)"
                        color="primary"
                        :allowed-minutes="allowedStep"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>

      <v-container>
        <br />
        <div class="text-xs-center" style="margin-bottom: 10px">
          <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
            <em class="far fa-eye" />
            {{ $t('preview') }}
          </a>
          <preview-message
            v-if="showPreview"
            @close="showPreview = false"
            :messages="messages"
            :choice="choices"
            :questions="questions"
            :isComment="false"
            :comment="''"
          ></preview-message>
          <input
            type="hidden"
            v-validate="'min_value:1'"
            :name="'messages'"
            v-model="messages[0].length"
            :data-vv-as="$t('Broadcast Messages')"
          />
          <div class="form-control mt-4" :class="{ 'has-error': errors.has('messages') }">
            <span class="text-error" v-show="errors.has('messages')">{{
              errors.first('messages')
            }}</span>
          </div>
        </div>
        <div class="text-xs-center mt-2">
          <v-btn color="grey" outline @click="onBack">
            <em class="fas fa-chevron-left mr-1" />
            {{ $t('Back') }}
          </v-btn>
          <v-btn color="grey" outline @click="onSave" v-if="!isSaveOnly">
            <i class="fas fa-save mr-1"></i>
            {{ $t('save_draft') }}
          </v-btn>
          <v-btn depressed @click="onSend" color="primary">
            <i class="fas fa-paper-plane mr-1"></i>
            {{ $t(isSaveOnly ? 'save_and_send' : 'Send') }}
          </v-btn>
        </div>
      </v-container>
    </template>

    <modal-dialog2 v-if="showUpgrade" @close="showUpgrade = false">
      <div slot="body" style="overflow: auto">
        <div style="position: relative">
          <v-premium-plan-popup :inline="true" backgroundColor="white"></v-premium-plan-popup>
        </div>
      </div>

      <div slot="footer">
        <div class="text-xs-center">
          <button
            type="button"
            class="btn btn-flat"
            data-dismiss="modal"
            @click="showUpgrade = false"
          >
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </modal-dialog2>
  </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import datepicker from 'vuejs-datepicker'
import IntentGroup from '@/components/view/intent/IntentGroup'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import TweenNum from 'vue-tween-number'
import ModalDialog2 from '@/components/elements/ModalDialog2'
import Tags from '@/components/elements/Tags'
import Multiselect from 'vue-multiselect'
import PreviewMessage from '@/components/elements/PreviewMessage'
import FilterCustomer from '@/components/elements/FilterCustomer'

export default {
  props: ['value', 'isSaveOnly'],

  data: function () {
    return {
      statusOptions: [],
      tagOptions: null,
      showSponser: false,
      showScheduleDate: false,
      showScheduleTime: false,
      scheduleDate: null,
      scheduleTime: null,
      showAdvanced: false,

      showPreview: false,
      questions: [],
      tagOptions: null,
      tag: '',
      usertag: '',
      singleStatus: '',
      showUpgrade: false,
      broadcast: undefined,
      notify: null,
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      update_status: '',
      update_tags: [],
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      groupTypeOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        },
        {
          label: this.$t('Customize'),
          value: 'customize'
        }
      ],
      intents: [],
      type: 'json',
      tntType: {
        label: this.$t('DAILY'),
        value: 'DAILY'
      },
      groupType: {
        label: this.$t('All'),
        value: ''
      },
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      choice: '',
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        }
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      tntTypeOption: [
        {
          label: this.$t('DAILY'),
          value: 'DAILY'
        },
        {
          label: this.$t('WEEKLY'),
          value: 'WEEKLY'
        },
        {
          label: this.$t('MONTHLY'),
          value: 'MONTHLY'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],
          enable: true
        }
      ],
      filter: {
        specialcondition: '',
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        tagtype: 'includes',
        status: '',
        statustype: 'includes',
        lamySendNotiMember: false,
        lamyDaySendNoti: '',
        lamy_member_type: '',
        member_status:'active'
      },
      errorTag: [],
      errorUsertag: [],
      errorFilterTag: [],
      errorFilterStatus: [],
      estimate_user: 0,
      count_optin_daily: 0,
      count_optin_daily_available: 0,
      count_optin_weekly: 0,
      count_optin_weekly_available: 0,
      count_optin_monthly: 0,
      count_optin_monthly_available: 0,
      total_user: '',
      loadingEstimate: true
    }
  },
  components: {
    datepicker,
    IntentGroup,
    GenericManage,
    MoveHorizontal,
    TweenNum,
    SyncLoader,
    ModalDialog2,
    Tags,
    Multiselect,
    PreviewMessage,
    FilterCustomer
  },
  mounted: function () {
    var vm = this
    vm.getUserTagList()
    vm.getUserStatusList()
    vm.reset()

    if (vm.name === '') {
      vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
    }

    if (vm.broadcast.scheduletime) {
      var scheduleDate = moment(vm.broadcast.scheduletime)
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = scheduleDate.format('HH:mm')
    } else {
      var scheduleDate = moment()
      vm.scheduleDate = scheduleDate.format('YYYY-MM-DD')
      vm.scheduleTime = parseInt(scheduleDate.format('HH')) + 1 + ':' + '00'
    }

    if (this.value && this.value.notify) {
      vm.notify = this.value.notify
    }

    if (this.value && this.value.m_condition) {
      let a = this.value.m_condition.split('&')
      let b = {}
      a.forEach((v) => {
        let x = v.split('=')
        b[x[0]] = x[1]
      })

      Object.assign(this.filter, b)

      let c = {
        uu_areaname: b.uu_areaname,
        uu_dma: b.uu_dma,
        uu_name: b.uu_name,
        uu_register_status: b.uu_register_status
      }
      Object.assign(this.filter, c)

      if (b.lamy_member_type) {
        let label = ''
        if (b.lamy_member_type == 'all') {
          label = 'ทุก Member Type'
        } else {
          label = b.lamy_member_type
        }

        let d = {
          lamy_member_type: {
            label: label,
            value: b.lamy_member_type
          }
        }
        Object.assign(this.filter, d)
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
      isCoachlab: 'isCoachlab'
    }),
    messageAvailableCount: function () {
      const vm = this
      if (vm.loadingLinePushMessageCount || vm.selectedBot.theme != 'universalutilities') {
        return false
      }
      if (vm.filter.uu_areaname == '' || vm.filter.uu_areaname == null) {
        return vm.linePushMessageCount.reduce((prev, curr) => {
          prev += parseInt(curr.count)
          return prev
        }, 0)
      }
      var area = vm.linePushMessageCount.find((el) => {
        return el.uu_areaname == vm.filter.uu_areaname
      })
      if (area) {
        return area.count
      } else {
        return 0
      }
    },
    filterIntent: function () {
      const vm = this
      if (vm.intents && vm.intents.length > 0) {
        vm.intents.sort(function (a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
            return 1
          }
          if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })
      }
      let intents = []
      if (vm.intents) {
        intents = vm.intents.map((intent) => intent.intentname, [])
      }
      return intents
    },
    choices: {
      get() {
        const vm = this
        if (vm.quick_reply && vm.quick_reply !== '') {
          const quickReplies = vm.quick_reply ? vm.quick_reply.split(',') : []
          return quickReplies ? quickReplies.map((val) => ({ text: val }), []) : []
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        if (value) {
          result = value.map((val) => val.text, [])
        }
        vm.quick_reply = result.join(',')
      }
    },
    tags: {
      get() {
        const vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          const tags = vm.filter.tags ? vm.filter.tags.split(',') : []
          let result = []
          if (tags) {
            result = tags.map((tag) => ({ text: tag }), [])
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        if (value) {
          result = value.map((tag) => tag.text)
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        const vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          const status = vm.filter.status ? vm.filter.status.split(',') : []
          return status ? status.map((s) => ({ text: s }), []) : []
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        var result = []
        if (value) {
          value.map(function (s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    },
    usertags: {
      get() {
        const vm = this
        if (
          vm.broadcast &&
          vm.broadcast.update_user_tags !== '' &&
          typeof vm.broadcast.update_user_tags !== 'undefined'
        ) {
          var usertags = []
          usertags = vm.broadcast.update_user_tags.split(',')
          usertags = usertags.filter((el) => {
            return el != ''
          })
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function (tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }
        vm.update_tags = result
      }
    },
    areaName: function () {
      return ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
    },
    availableBubbles: function () {
      let bubbles = this.$store.state.defaultBubbleList
      if (this.groupType && this.groupType.value === 'facebook') {
        const tempBubbles = bubbles
        const exceptBubbles = ['line_flex', 'line_imagemap', 'line_sticker']
        const filteredBubble = tempBubbles.filter((item) => !exceptBubbles.includes(item))
        bubbles = filteredBubble
      }
      return bubbles
    }
  },
  methods: {
    onSelectStatus(value) {
      this.update_status = value
    },
    checkUserTags(obj) {
      this.errorUsertag = []
      if (obj.tag.text.length > 20) {
        this.errorUsertag.push('overmaxlength')
        obj.error()
      } else if (this.choices.length >= 10) {
        this.errorUsertag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorUsertag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        this.tagOptions = response.result.map((item) => {
          return item.name
        })
      }
    },

    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        this.statusOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.update_tags.push(tag)
    },
    allowedStep: (m) => m % 10 === 0,
    onChangeStatus() {
      if (this.groupType === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.estimateReach(this.groupType)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(this.groupType)
      }
    },
    onBroadcastSchedule() {
      this.$set(this.broadcast, 'isschedule', !this.broadcast.isschedule)
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 99999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    addChoices: function (newTags) {
      this.choices = newTags
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.choices.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
    getIntent: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.intents = response.data
        }
        callback()
      })
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    onOptionChange: function (option) {
      this.type = option
    },
    onDeleteGeneric: function (index) {
      if (this.generics.length > 1) {
        this.generics.splice(index, 1)
      } else {
        alert('Generic Message cannot be less than 1')
      }
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function () {
      if (this.generics.length < 10) {
        this.generics.push({
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        })
      }
    },
    onBack: function () {
      var vm = this
      vm.$emit('onClose')
    },
    onSave: function () {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()

          return false
        }
        vm.$store.dispatch('loading')
        vm.updateBroadcast(false, function (status) {
          if (status) {
            vm.$swal.fire({
              title: vm.$t('Success! Broadcast {name} save', {
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          } else {
            vm.$swal.fire({
              title: vm.$t('Oop! Broadcast {name} save draft fail', {
                name: vm.name.replace(/\<|\>/g, '')
              }),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          }

          $('html, body').animate({ scrollTop: 0 })

          vm.$store.dispatch('loading')
        })
      })
    },
    onSend: function () {
      var vm = this

      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.groupType.value === 'customize' && vm.$store.getters.getPackage !== 'premium') {
          vm.showUpgrade = true
          return false
        }
        vm.$swal
          .fire({
            title: vm.$t('Do you want to broadcast {name}?', {
              name: vm.name.replace(/\<|\>/g, '')
            }),
            html: `<small><span class="warning--text">${vm.$t('Warning!')}</span>${vm.$t(
              'If you send too many broadcasts,your inbox might not be able to access temporarily.'
            )}<small>
            <div class="subheading mt-2" style="line-height: 27px !important;">
            <span class="warning--text">${vm.$t('Warning!')}</span>
            ${vm.$t(
              'You messages must follow the Message Type’s regulation. To avoid being blocked by Facebook, please recheck them before sending the broadcast.'
            )}</div>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then((result) => {
            if (result.value) {
              vm.$store.dispatch('loading')
              vm.updateBroadcast(true, function (status) {
                if (status) {
                  vm.$swal
                    .fire({
                      title: vm.$t('Broadcast {sent_name} sent', {
                        sent_name: vm.name.replace(/\<|\>/g, '')
                      }),
                      type: 'success',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true
                    })
                    .then(function () {
                      vm.$emit('onClose', vm.name)
                    })
                } else {
                  vm.$swal.fire({
                    title: vm.$t('Oop! Broadcast {name} save draft fail', {
                      name: vm.name.replace(/\<|\>/g, '')
                    }),
                    type: 'error',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                }
                vm.$store.dispatch('loading')
              })
            }
          })
      })
    },
    updateBroadcast: function (isSend, callback) {
      var vm = this
      var scheduletime = moment(vm.scheduleDate + ' ' + vm.scheduleTime)
      var scheduletimeUTC = moment.utc(scheduletime)
      var data = {
        pageid: vm.selectedBot.pageid,
        name: vm.name,
        m_val: vm.message,
        m_type: 'json',
        m_quick_reply: vm.quick_reply,
        m_condition: '',
        sendflag: isSend,
        page_access_token: vm.selectedBot.page_access_token,
        pushtype: vm.pushtype,
        sendtype: vm.sendtype,
        update_status: vm.update_status,
        notify: vm.notify,
        update_tags: vm.update_tags.join(',')
      }

      if (vm.sendtype === 'NTN_BROADCAST') {
        if (vm.tntType.value === 'DAILY') {
          data.sendtype = 'opt_in_daily'
        } else if (tntType.value === 'WEEKLY') {
          data.sendtype = 'opt_in_weekly'
        } else if (tntType.value === 'MONTHLY') {
          data.sendtype = 'opt_in_monthly'
        } else {
          data.sendtype = false
        }
      }

      if (vm.$store.getters.getPackage == 'premium' && !vm.isCoachlab) {
        data.isschedule = vm.broadcast.isschedule
        data.scheduletime = scheduletimeUTC.format('YYYY-MM-DDTHH:mm:ss.sssZ')
      } else {
        data.isschedule = false
        data.scheduletime = null
      }
      if (vm.groupType.value === 'facebook') {
        data.m_condition = 'app=facebook'
      } else if (vm.groupType.value === 'line') {
        data.m_condition = 'app=line'
      } else if (vm.groupType.value === 'customize') {
        data.filter = vm.filter
      }

      if (vm.broadcast && vm.broadcast.id) {
        data.broadcastid = vm.broadcast.id
      }

      if ([...vm.$store.state.lamyPage].includes(vm.selectedBot.pageid)) {
        if (vm.filter.lamySendNotiMember) {
          data.lamy_member_expired_status = vm.filter.lamySendNotiMember
          data.lamy_member_expired_day = vm.filter.lamyDaySendNoti
        } else {
          data.lamy_member_expired_status = vm.filter.lamySendNotiMember
        }
      }
      var messages = vm.checkEmptyMessage(vm.messages)

      if (isSend == true && (messages.length == 0 || messages[0].length == 0)) {
        callback(false)
        return false
      }

      data.m_val = JSON.stringify(messages)

      vm.$emit('onSave', {
        data: data,
        onSave: function (status, broadcastid) {
          if (status) {
            if (broadcastid) {
              data.id = broadcastid
            }
            vm.broadcast = data
            vm.cached_broadcast = Object.assign({}, vm.broadcast)
          }
          callback(status)
        }
      })
    },
    estimateReach: function (type) {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      if (type === 'customize') {
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            vm.filter.uu_areaname = vm.selectedBot.uu_areaname
          }
        }
        data.filter = vm.filter
        if (data.filter.uu_areaname == 'ทุกพื้นที่') {
          data.filter.uu_areaname = ''
        }

        // LAMY
        if ([...vm.$store.state.lamyPage].includes(vm.selectedBot.pageid)) {
          if (vm.filter.lamySendNotiMember) {
            Object.assign(data, {
              lamy_member_expired_status: vm.filter.lamySendNotiMember,
              lamy_member_expired_day: vm.filter.lamyDaySendNoti
            })
          } else {
            Object.assign(data, {
              lamy_member_expired_status: vm.filter.lamySendNotiMember
            })
          }

          if (vm.filter.lamy_member_type) {
            Object.assign(data, {
              lamy_member_type: vm.filter.lamy_member_type.value
            })
          }
        }
      } else {
        if (type === 'facebook') {
          Object.assign(data, { app: 'facebook' })
        } else if (type === 'line') {
          Object.assign(data, { app: 'line' })
        }
      }

      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingEstimate = false
          return
        }
        if (response.data) {
          vm.estimate_user = response.data.count
          vm.total_user = response.data.total
          vm.count_optin_daily = response.data.count_optin_daily
          vm.count_optin_daily_available = response.data.count_optin_daily_available
          vm.count_optin_weekly = response.data.count_optin_weekly
          vm.count_optin_weekly_available = response.data.count_optin_weekly_available
          vm.count_optin_monthly = response.data.count_optin_monthly
          vm.count_optin_monthly_available = response.data.count_optin_monthly_available
        } else {
          vm.estimate_user = 0
        }
        vm.$nextTick(function () {
          vm.loadingEstimate = false
        })
      })
    },
    onSelectGroupType: function (type) {
      if (type.value === 'customize') {
        if (this.$store.getters.getPackage === 'premium' && !this.isCoachlab) {
          this.estimateReach(type.value)
        } else {
          this.estimateReach('')
        }
      } else {
        this.estimateReach(type.value)
      }
    },
    reset: function () {
      var vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)

        this.update_status = vm.broadcast.update_user_status
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter((el) => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function (filter) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'status':
                case 'tags':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__'
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__'
                    }
                  }
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal, clindex) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter((el) => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  return { id: 'activeDate_start', value: moment(value[1]).toDate() }
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  return { id: 'activeDate_end', value: moment(value[1]).toDate() }
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  return { id: 'registerDate_start', value: moment(value[1]).toDate() }
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  return { id: 'registerDate_end', value: moment(value[1]).toDate() }
              }
            }
          })
          if (f.length == 1 && (vm.filter['app'] == 'facebook' || vm.filter['app'] == 'line')) {
            vm.groupType =
              vm.filter['app'] == 'facebook' ? vm.groupTypeOptions[1] : vm.groupTypeOptions[2]
          } else {
            vm.groupType = vm.groupTypeOptions[3]
          }
        } else {
          vm.groupType = vm.groupTypeOptions[0]
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype ? vm.broadcast.sendtype : 'promotion'
        vm.sendtype =
          vm.value && vm.value.sendtype == 'opt_in_daily' ? 'NTN_BROADCAST' : vm.sendtype
        vm.pushtype = vm.broadcast.pushtype ? vm.broadcast.pushtype : 'SILENT_PUSH'

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          try {
            vm.messages = JSON.parse(vm.broadcast.m_val)
          } catch (error) {}
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function (index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = {
          m_condition: null,
          name: null,
          m_type: 'json',
          m_quick_reply: null,
          m_val: null
        }
        vm.isSave = false
        vm.isFail = false
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.messages = [[]]
        vm.choice = ''
        vm.errorTag = []
        vm.errorUsertag = []
        vm.estimate_user = 0
      }
      vm.$nextTick(function () {
        if (vm.selectedBot.theme == 'universalutilities') {
          vm.groupType = {
            label: this.$t('Customize'),
            value: 'customize'
          }
        }

        if (vm.groupType.value == 'customize') {
          if (vm.$store.getters.getPackage == 'premium') {
            vm.estimateReach(vm.groupType.value)
          } else {
            vm.estimateReach('')
          }
        } else {
          vm.estimateReach(vm.groupType.value)
        }
      })

      if (vm.name == '') {
        vm.name = 'Broadcast_' + moment().format('YYYY_MM_DD_HH_mm')
      }
    }
  },
  watch: {
    value: function () {
      this.reset()
    },
    filter: {
      handler: function () {
        if (
          this.groupType.value == 'customize' &&
          this.$store.getters.getPackage == 'premium' &&
          !this.isCoachlab
        ) {
          this.estimateReach(this.groupType.value)
        }
      },
      deep: true
    },
    groupType: function () {},
    showSponser: function (newVal, oldVal) {
      if (newVal == false && oldVal == true) {
        this.sendtype = 'promotion'
      }
    },
    sendtype: function (newVal) {
      if (newVal == 'sponsered') {
        this.showSponser = true
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastManage.vue